$(document).ready(function () {
  function updateTotalPrice() {
    let total = 0;
    let totalCompare = 0;
    let checkedCount = 0;
    let totalItems = $('.look-product-checkbox').length;
    const discountRate = parseFloat($('.shop-the-look').data('discount'));

    $('.look-product-checkbox:checked').each(function () {
      const productCard = $(this).closest('.look-product');
      const price = parseFloat(productCard.data('price'));
      const compare = parseFloat(productCard.data('compare'));
      total += price;
      totalCompare += compare;
      checkedCount++;
    });

    const discountedTotal = totalCompare * (1 - discountRate);
    $('#original-price').html(`$${totalCompare.toFixed(2)}`).css('text-decoration', 'line-through');
    $('#discounted-price').html(`$${discountedTotal.toFixed(2)}`);
    $('.look-discounted-price').show();
    $('.look-original-price').addClass('discount-active');

  }

  // Inicial
  updateTotalPrice();

  // Evento al cambiar selección
  $(document).on('change', '.look-product-checkbox', function () {
    updateTotalPrice();
    $('#shop-the-look-message').fadeOut(200);
  });
});


$('#add-to-cart-look').on('click', function () {

  var $button = $(this);
  var originalText = $button.text();
  $button.prop('disabled', true);
  $button.text('Adding...');

  var $checkedCheckboxes = $('.look-product-checkbox:checked');
  var productosData = [];
  $($checkedCheckboxes).each(function(index) {
      var $val = $(this).closest('.look-product').data('variant-id');
      var objeto = {
          id: $val,
          quantity: 1
      };
      productosData.push(objeto);
  });

  if (productosData.length === 0) {
    $('#shop-the-look-message').text('Please select at least one product.').css('color', 'red').show();
    $button.text(originalText);
    $button.prop('disabled', false);
    return;
  }

  $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: productosData
      },
      dataType: 'json',
      success: function() {
        console.log('Productos al carrito');
        $button.text('Added!');
        setTimeout(function () {
          $button.text(originalText);
          $button.prop('disabled', false);
        }, 2000);
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.log('Error al agregar los productos al carrito');
        console.log('Estado del texto:', textStatus);
        console.log('Error lanzado:', errorThrown);
        console.log('Respuesta del servidor:', XMLHttpRequest.responseText);
        $button.text(originalText);
        $button.prop('disabled', false);
      }
  });

});

